<template>
  <div>
    <CRow>
      <CCol xs="6" sm="6" md="6" lg="6" xl="6" class="mb-2">
        <button type="button" class="btn btn-sm btn-outline-main bg-purple color-white" @click="returnHome">
          <i class="fas fa-home-lg-alt"></i>&nbsp;&nbsp;Inicio
        </button>
      </CCol>
      <CCol xs="6" sm="6" md="6" lg="6" xl="6" class="mb-2 text-right">
        <button @click="mtdOpenModalExpense" class="btn btn-lg btn-warning btn-md mx-1">
          <b><i class="fab fa-creative-commons-nc"></i>&nbsp; Egresos</b>
        </button>
        <button @click="mtdOpenModalRetirementDeposit" class="btn btn-lg btn-success btn-md mx-1">
          <b><i class="far fa-money-bill-alt"></i>&nbsp; Depósito/Retiro</b>
        </button>
        <button @click="mtdCloseBead" class="btn btn-lg btn-danger btn-md">
          <b><i class="fas fa-cash-register"></i>&nbsp;Cerrar Caja</b>
        </button>
      </CCol>
    </CRow>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="2" xl="2">
        <CCard>
          <CCardHeader class="bg-gris text-center font-weight-bold">
            <span>Total Efectivo</span>
          </CCardHeader>
          <CCardBody class="border">
            <div>Apertura: {{ this.bead.initial }}</div>
          </CCardBody>
          <CCardBody class="border" style="cursor: pointer" @click="mtdOpenModalIncome('ingreso')">
            <div>Ingresos: {{ this.bead.income }}</div>
          </CCardBody>
          <CCardBody class="border" style="cursor: pointer" @click="mtdOpenModalIncome('egreso')">
            <div>Egresos: {{ this.bead.expense }}</div>
          </CCardBody>
          <CCardBody class="border" style="cursor: pointer" @click="mtdOpenModalMovement('retiro')">
            <div>Retiros: {{ this.sumaRetiro() }}</div>
          </CCardBody>
          <CCardBody class="border" style="cursor: pointer" @click="mtdOpenModalMovement('deposito')">
            <div>Depósito: {{ this.sumaDeposito() }}</div>
          </CCardBody>
          <CCardBody class="border">
            <div>
              <b>Total: {{ this.bead.final }} </b>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="2" xl="2">
        <CCard>
          <CCardHeader class="bg-gris text-center font-weight-bold">
            <span>Otros Ingresos</span>
          </CCardHeader>
          <template v-for="(method, index) in data_methodpayment">
            <CCardBody v-if="method.name != 'EFECTIVO'" :key="index" class="border" style="cursor: pointer"
              @click="handleMethodPayment(method.name)">
              <div>{{ method.name }}: {{ getMethodValue(method.name) }}</div>
            </CCardBody>
          </template>
        </CCard>
        <div class="d-flex justify-content-end"></div>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="2" xl="2">
        <CCard>
          <CCardHeader class="bg-gris text-center font-weight-bold">
            <span>Otros Egresos</span>
          </CCardHeader>
          <template v-if="castExpense.length > 0">
            <template v-for="(item, index) in castExpense">
              <CCardBody v-if="item.name != 'EFECTIVO'" :key="index" class="border" style="cursor: pointer"
                @click="handleMethodPaymentEgreso(item.name)">
                <div>
                  {{ item.name }}: {{ parseFloat(item.amount).toFixed(2) }}
                </div>
              </CCardBody>
            </template>
          </template>
          <template v-else>
            <CCardBody class="border" style="cursor: pointer">
              <div>
                NO TIENE OTROS EGRESOS
              </div>
            </CCardBody>
          </template>
        </CCard>
        <div class="d-flex justify-content-end"></div>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="6" xl="6">
        <CCard>
          <CCardHeader class="bg-gris text-center font-weight-bold">
            <span>Arqueo de cierre de caja</span>
          </CCardHeader>
          <CCardBody>
            
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="4" xl="4">
                <CInput type="text" disabled v-model="this.bead.final" label="Efectivo Sistema" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="4" xl="4">
                <CInput type="text" v-model="finalCash" label="Efectivo Caja" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="4" xl="4">
                <CInput type="text" disabled v-model="cpDiferencia" :label="labelDiferencia" />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <div class="container mx-auto p-4">
      <cModalIncome :title="modalIncome.title" :boo_modal="modalIncome.modal_form" :incomes="modalIncome.income"
        :incomes_reserva="modalIncome.income_reserva" :type="modalIncome.type" :currentMethodId="modalIncome.currentMethodId"
        :allMethods="data_methodpayment" @closeModalIncome="closeModalIncome" @onChangePaymentMethod="handleChangePaymentMethod" />
      <cModalRetirementDeposit :title="modalRetirementDeposit.title" :boo_modal="modalRetirementDeposit.modal_form"
        :bead_id="modalRetirementDeposit.bead_id" :bead_final="modalRetirementDeposit.bead_final"
        @closeModalRetirementDeposit="closeModalRetirementDeposit" @mtdRefreshData="mtdRefreshData" @resetData="resetData"/>
      <cModalMovement :title="modalMovement.title" :boo_modal="modalMovement.modal_form"
        :movements="modalMovement.movement" :type="modalMovement.type" @closeModalMovement="closeModalMovement" />
      <cModalOtrosIngresos :title="modalData.title" :boo_modal="modalData.modal_form" :data="modalData.data"
        :data_reserva="modalData.data_reserva" :currentMethodId="modalData.currentMethodId" :allMethods="data_methodpayment"
        @closeModal="closeModal" @onChangePaymentMethod="handleChangePaymentMethod" />
      <cModalOtrosEgresos :title="modalDataEgresos.title" :boo_modal="modalDataEgresos.modal_form"
        :data="modalDataEgresos.data" :data_reserva="modalDataEgresos.data_reserva" @closeModal="closeModalEgresos"/>
      <!-- modal expense -->
      <CModalExpense :title="modalExpense.title" :boo_modal="modalExpense.modal_form" :types="modalExpense.type"
        :method="modalExpense.method" @mtdRefreshData="mtdRefreshData" @closeModalExpense="closeModalExpense"
        @commitModalExpense="commitModalExpense" @resetData="resetData"/>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import cModalIncome from "../modals/cModalIncome.vue";
import cModalRetirementDeposit from "../modals/cModalRetiremetDeposit.vue";
import cModalMovement from "../modals/cModalMovement.vue";
import cModalOtrosIngresos from "../modals/cModalOtrosIngresos.vue";
import cModalOtrosEgresos from "../modals/cModalOtrosEgresos.vue";
import CModalExpense from "../modals/cModalExpense.vue";

export default {
  name: "close-bead",
  components: {
    cModalIncome,
    cModalRetirementDeposit,
    cModalMovement,
    cModalOtrosIngresos,
    CModalExpense,
    cModalOtrosEgresos
  },
  data() {
    return {
      prefix: "beads",
      // Nuevos
      data_efectivo_egreso: [],
      data_transferencia_egreso: [],
      data_tarjeta_egreso: [],
      data_deposito_egreso: [],
      data_yape_egreso: [],
      data_plin_egreso: [],
      // fin nuevos
      data_methodpayment: [],
      data_charge: [],
      data_ingresos_reserva: [],
      data_transferencia_reserva: [],
      data_tarjeta_reserva: [],
      data_deposito_reserva: [],
      data_yape_reserva: [],
      data_plin_reserva: [],
      data_ingresos: [],
      data_transferencia: [],
      data_tarjeta: [],
      data_deposito: [],
      data_yape: [],
      data_plin: [],
      data_egresos: [],
      all_data_egresos: [],
      verificBead: false,
      bead: {
        id: "",
        box_id: "",
        user_id: this.$store.getters.get__user_id,
        campu_id: this.$store.getters.get_campu.id,
        company_id: this.$store.getters.get_company.id,
        initial: "",
        final: "",
        expense: "",
        income: "",
        card: "",
        turned: "",
        transfer: "",
        retirement: "",
        status_open: "",
        status_close: "",
        deposit: "",
        authorize: "",
        state: "",
      },
      process: {
        box_id: "",
        bead_id: "",
        otrosEgresos: [],
        otroIngresos: [
          {
            label: "Transferencia",
            total: 0,
          },
          {
            label: "Tarjeta",
            total: 0,
          },
          {
            label: "Deposito",
            total: 0,
          },
          {
            label: "Yape",
            total: 0,
          },
          {
            label: "Plin",
            total: 0,
          },
        ],
        observation: "",
        totIncome: 0,
        totExpense: 0,
        retirement: 0,
        deposit_efectivo: 0,
        initial: 0,
        final: 0,
      },
      modalIncome: {
        title: "Ingresos",
        modal_form: false,
        income: [],
        income_reserva: [],
        type: "",
      },
      modalMovement: {
        title: "Retiro",
        modal_form: false,
        movement: [],
        type: "",
      },
      modalRetirementDeposit: {
        title: "",
        modal_form: false,
        bead_id: "",
        bead_final: 0,
      },
      modalData: {
        title: "",
        modal_form: false,
        data: [],
        data_reserva: [],
      },
      modalDataEgresos: {
        title: "",
        modal_form: false,
        data: [],
        data_reserva: [],
      },
      incomes: [],
      movement: [],
      movement_retiros: [],
      movement_depositos: [],
      /** expense */
      expenses: [],
      types: [],
      modalExpense: {
        title: "Expense",
        modal_form: false,
        type: [],
        method: [],
      },
      /** arqueo */
      finalCash: 0,
      labelDiferencia: 'Falta',
      diferencia: 0
    };
  },
  watch: {
    "bead.id": function (newId) {
      if (newId) {
        this.mtdReportBeads();
        this.showChargue();
        this.showMovement();
      }
    },
  },
  computed: {
    castExpense() {
      let cast = [];
      this.expenses.forEach((element) => {
        let temp = cast.filter((el) => el.name == element.method_payment.name);
        if (temp.length == 0) {
          cast.push({
            method_payment_id: element.method_payment_id,
            name: element.method_payment.name,
            amount: parseFloat(element.amount).toFixed(2),
          });
        } else {
          cast.forEach((el) => {
            if (el.name == element.method_payment.name) {
              el.amount = parseFloat(el.amount) + parseFloat(element.amount);
            }
          });
        }
      });

      this.process.otrosEgresos = cast;
      return cast;
    },
    cpDiferencia() {
      let dif = parseFloat(this.bead.final) - parseFloat(this.finalCash);
      if (dif > 0) {
        this.diferencia = parseFloat(dif).toFixed(2);
        this.labelDiferencia = 'Falta';
      } else if (dif < 0) {
        this.diferencia = parseFloat(dif * -1).toFixed(2);
        this.labelDiferencia = 'Sobra';
      } else {
        this.diferencia = parseFloat(dif).toFixed(2);
        this.labelDiferencia = 'Exacto';
      }
      this.process.finalCash = this.finalCash;
      return this.diferencia;
    }
  },
  created() {
    this.mtdGetData();
    // this.showBead();
    // this.showMethodPayment();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome: function () {
      this.$emit("setView", "home");
    },
    mtdRefreshData() {
      this.mtdGetData();
      this.mtdReportBeads();
      this.showMovement();
      this.showChargue();
    },
    mtdGetData: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/index/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.verificBead = response.data.bead ? true : false;
            this.bead = this.verificBead == true ? response.data.bead : {};
            this.data_methodpayment = [];
            response.data.methodPayment.forEach((arr) => {
              this.data_methodpayment.push(arr);
            });
            this.types = [];
            response.data.type.forEach((element) => {
              this.types.push({
                label: element.name,
                value: element.id,
              });
            });
            this.expenses = response.data.expenses;
          }
        })
        .catch((errors) => { });
    },
    mtdReportBeads: function () {
      this.get({
        url:
          this.$store.getters.get__url + "/beads/reportClose/" + this.bead.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.incomes = response.data;
            this.process.initial = this.bead.initial;
            this.process.totIncome = this.bead.income;
            this.process.final = this.bead.final;
            this.process.bead_id = this.bead.id;
            this.process.box_id = this.bead.box_id;
            this.process.deposit_efectivo = this.bead.deposit_cash;
            this.process.retirement = this.bead.retirement;
            this.process.totExpense = this.expenses;
            this.completedJson();
          }
        })
        .catch((errors) => { });
    },
    completedJson: function () {
      const totals = {
        EFECTIVO: 0,
        DEPOSITO: 0,
        TARJETA: 0,
        YAPE: 0,
        TRANSFERENCIA: 0,
        PLIN: 0,
      };

      // Usar los arrays procesados en lugar de this.incomes
      totals.TARJETA = this.data_tarjeta.reduce((sum, item) => sum + parseFloat(item.amount), 0);
      totals.TRANSFERENCIA = this.data_transferencia.reduce((sum, item) => sum + parseFloat(item.amount), 0);
      totals.DEPOSITO = this.data_deposito.reduce((sum, item) => sum + parseFloat(item.amount), 0);
      totals.YAPE = this.data_yape.reduce((sum, item) => sum + parseFloat(item.amount), 0);
      totals.PLIN = this.data_plin.reduce((sum, item) => sum + parseFloat(item.amount), 0);
      totals.EFECTIVO = this.data_ingresos.reduce((sum, item) => sum + parseFloat(item.amount), 0);
      
      //completar el json
      this.process.otroIngresos.forEach((ele) => {
        if (ele.label == "Transferencia") {
          ele.total = parseFloat(totals["TRANSFERENCIA"]);
        }
        if (ele.label == "Tarjeta") {
          ele.total = parseFloat(totals["TARJETA"]);
        }
        if (ele.label == "Deposito") {
          ele.total = parseFloat(totals["DEPOSITO"]);
        }
        if (ele.label == "Yape") {
          ele.total = parseFloat(totals["YAPE"]);
        }
        if (ele.label == "Plin") {
          ele.total = parseFloat(totals["PLIN"]);
        }
      });
    },
    mtdCloseBead() {
      if (this.finalCash > 0) {
        this.process.billetes = null;
        this.process.monedas = null;
        this.post({
          url: this.$store.getters.get__url + "/beads/close",
          token: this.$store.getters.get__token,
          params: {
            bead: this.bead,
            process: this.process,
          },
        })
          .then((response) => {
            if (response.statusCode == 200) {
              Swal.fire({
                title: "Caja Cerrada Correctamente",
                icon: "success",
              });
              //volver
              this.exportPdf();
              this.returnHome();
            }
          })
          .catch((errors) => {
            Swal.fire({
              title: errors,
              icon: "danger",
            });
          });
      } else {
        Swal.fire({
          title: "Digite arqueo",
          icon: "warning",
        });
      }
    },
    handleMethodPayment(methodName) {
      switch (methodName) {
        case "TRANSFERENCIA":
          this.mtdOpenModal("transfer");
          break;
        case "TARJETA":
          this.mtdOpenModal("card");

          break;
        case "DEPOSITO":
          this.mtdOpenModal("deposit");
          break;
        case "YAPE":
          this.mtdOpenModal("yape");
          break;
        case "PLIN":
          this.mtdOpenModal("plin");
          break;
        default:
          console.warn("Método de pago no soportado:", methodName);
      }
    },
    handleMethodPaymentEgreso(methodName) {
      switch (methodName) {
        case "TRANSFERENCIA":
          this.mtdOpenModalEgreso("transfer");
          break;
        case "TARJETA":
          this.mtdOpenModalEgreso("card");

          break;
        case "DEPOSITO":
          this.mtdOpenModalEgreso("deposit");
          break;
        case "YAPE":
          this.mtdOpenModalEgreso("yape");
          break;
        case "PLIN":
          this.mtdOpenModalEgreso("plin");
          break;
        default:
          console.warn("Método de pago no soportado:", methodName);
      }
    },
    getMethodValue(methodName) {
      switch (methodName) {
        case "TRANSFERENCIA":
          return this.sumaTransferencia();
        case "TARJETA":
          return this.sumaTarjeta();
        case "DEPOSITO":
          return this.sumaDeposito();
        case "YAPE":
          return this.sumaYape();
        case "PLIN":
          return this.sumaPlin();
        default:
          return null;
      }
    },
    mtdOpenModal(type) {
      let title, data, data_reserva, currentMethodId;
      switch (type) {
        case "transfer":
          title = "Transferencia";
          data = this.data_transferencia;
          data_reserva = this.data_transferencia_reserva;
          currentMethodId = this.data_methodpayment.find(method => method.name == 'TRANSFERENCIA')?.id;
          break;
        case "card":
          title = "Tarjeta";
          data = this.data_tarjeta;
          data_reserva = this.data_tarjeta_reserva;
          currentMethodId = this.data_methodpayment.find(method => method.name == 'TARJETA')?.id;
          break;
        case "deposit":
          title = "Deposito";
          data = this.data_deposito;
          data_reserva = this.data_deposito_reserva;
          currentMethodId = this.data_methodpayment.find(method => method.name == 'DEPOSITO')?.id;
          break;
        case "yape":
          title = "Yape";
          data = this.data_yape;
          data_reserva = this.data_yape_reserva;
          currentMethodId = this.data_methodpayment.find(method => method.name == 'YAPE')?.id;
          break;
        case "plin":
          title = "Plin";
          data = this.data_plin;
          data_reserva = this.data_plin_reserva;
          currentMethodId = this.data_methodpayment.find(method => method.name == 'PLIN')?.id;
          break;
        default:
          return;
      }

      this.modalData = {
        title: title,
        modal_form: true,
        data: data,
        data_reserva: data_reserva,
        currentMethodId: currentMethodId,
      };

    },
    mtdOpenModalEgreso(type) {
      let title, data, data_reserva;
      switch (type) {
        case "transfer":
          title = "Transferencia";
          data = this.data_transferencia_egreso;
          break;
        case "card":
          title = "Tarjeta";
          data = this.data_tarjeta_egreso;
          break;
        case "deposit":
          title = "Deposito";
          data = this.data_deposito_egreso;
          break;
        case "yape":
          title = "Yape";
          data = this.data_yape_egreso;
          break;
        case "plin":
          title = "Plin";
          data = this.data_plin_egreso;
          break;
        default:
          return;
      }

      this.modalDataEgresos = {
        title: title,
        modal_form: true,
        data: data,
        data_reserva: data_reserva,
      };
    },
    closeModal() {
      this.modalData.modal_form = false;
    },
    closeModalEgresos() {
      this.modalDataEgresos.modal_form = false;
    },
    mtdOpenModalIncome(type) {
      // Obtener el ID del método EFECTIVO
      const efectivoMethod = this.data_methodpayment.find(method => method.name == 'EFECTIVO');
      
      this.modalIncome = {
        title: type == "ingreso" ? "Ingresos" : "Egresos",
        modal_form: true,
        income: type == "ingreso" ? this.data_ingresos : this.data_egresos,
        income_reserva: type == "ingreso" ? this.data_ingresos_reserva : [],
        type: type,
        currentMethodId: efectivoMethod ? efectivoMethod.id : null,
      };
    },
    closeModalIncome() {
      this.modalIncome.modal_form = false;
    },
    mtdOpenModalMovement(type) {
      this.modalMovement = {
        title: type == "retiro" ? "Retiro" : "Depósito",
        modal_form: true,
        movement:
          type == "retiro" ? this.movement_retiros : this.movement_depositos,
        type: type,
      };
    },
    closeModalMovement() {
      this.modalMovement.modal_form = false;
    },
    mtdOpenModalRetirementDeposit() {
      this.modalRetirementDeposit = {
        title: "Registrar Retiros o Depósitos",
        modal_form: true,
        bead_id: this.bead.id ? this.bead.id : "",
        bead_final: this.bead.final ? this.bead.final : 0.0,
      };
    },
    resetData(){
      this.movement = [];
      this.movement_depositos = [];
      this.movement_retiros = [];
      this.data_efectivo_egreso= [];
      this.data_transferencia_egreso= [];
      this.data_tarjeta_egreso= [];
      this.data_deposito_egreso= [];
      this.data_yape_egreso= [];
      this.data_plin_egreso= [];
      this.data_methodpayment= [];
      this.data_charge= [];
      this.data_ingresos_reserva= [];
      this.data_transferencia_reserva= [];
      this.data_tarjeta_reserva= [];
      this.data_deposito_reserva= [];
      this.data_yape_reserva= [];
      this.data_plin_reserva= [];
      this.data_ingresos= [];
      this.data_transferencia= [];
      this.data_tarjeta= [];
      this.data_deposito= [];
      this.data_yape= [];
      this.data_plin= [];
      this.data_egresos= [];
      this.all_data_egresos= [];
      this.incomes= [];
      this.movement= [];
      this.movement_retiros= [];
      this.movement_depositos= [];
      this.expenses= [];
      this.types= [];
    },
    closeModalRetirementDeposit() {
      this.modalRetirementDeposit = {
        modal_form: false,
      };
    },
    showMovement() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/filterMovement/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.bead.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.movement = response.data;
            this.movement.forEach((item) => {
              if (item.type == 1) {
                this.movement_depositos.push(item);
              } else if (item.type == 2) {
                this.movement_retiros.push(item);
              }
            });
          }
        })
        .catch((errors) => { });
    },
    showChargue() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/filterChargue/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.bead.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200){
            this.data_charge = response.data.charge;
            
            this.data_egresos = response.data.expenses.filter(expense => expense.method_payment.name == "EFECTIVO");
            this.all_data_egresos = response.data.expenses
            this.filterIncomes();
            this.completedJson();
          }
        })
        .catch((errors) => { });
    },
    filterIncomes() {
      // Limpiar arrays antes de filtrar para evitar duplicación
      this.data_ingresos_reserva = [];
      this.data_transferencia_reserva = [];
      this.data_tarjeta_reserva = [];
      this.data_deposito_reserva = [];
      this.data_yape_reserva = [];
      this.data_plin_reserva = [];
      
      // Limpiar también arrays de ventas normales (type == 0)
      this.data_ingresos = [];
      this.data_transferencia = [];
      this.data_tarjeta = [];
      this.data_deposito = [];
      this.data_yape = [];
      this.data_plin = [];
      
      this.data_charge.forEach((element) => {
        
        if (element.sale.type == 1) {
          if (element.method == "EFECTIVO") {
            this.data_ingresos_reserva.push(element);
          }
          if (element.method == "TRANSFERENCIA") {
            this.data_transferencia_reserva.push(element);
          }
          if (element.method == "TARJETA") {
            this.data_tarjeta_reserva.push(element);
          }
          if (element.method && element.method.toUpperCase() == "DEPOSITO") {
            this.data_deposito_reserva.push(element);
          }
          if (element.method == "YAPE") {
            this.data_yape_reserva.push(element);
          }
          if (element.method == "PLIN") {
            this.data_plin_reserva.push(element);
          }
        }

        if (element.sale.type == 0) {
          if (element.method == "EFECTIVO") {
            this.data_ingresos.push(element);
          }
          if (element.method == "TRANSFERENCIA") {
            this.data_transferencia.push(element);
          }
          if (element.method == "TARJETA") {
            this.data_tarjeta.push(element);
          }
          if (element.method && element.method.toUpperCase() == "DEPOSITO") {
            this.data_deposito.push(element);
          }
          if (element.method == "YAPE") {
            this.data_yape.push(element);
          }
          if (element.method == "PLIN") {
            this.data_plin.push(element);
          }
        }
      });
      

      this.all_data_egresos.forEach((newElement) => {
        if (newElement.method_payment.name == "EFECTIVO") {
          this.data_efectivo_egreso.push(newElement);
        }
        if (newElement.method_payment.name == "TRANSFERENCIA") {
          this.data_transferencia_egreso.push(newElement);
        }
        if (newElement.method_payment.name == "TARJETA") {
          this.data_tarjeta_egreso.push(newElement);
        }
        if (newElement.method_payment.name && newElement.method_payment.name.toUpperCase() == "DEPOSITO") {
          this.data_deposito_egreso.push(newElement);
        }
        if (newElement.method_payment.name == "YAPE") {
          this.data_yape_egreso.push(newElement);
        }
        if (newElement.method_payment.name== "PLIN") {
          this.data_plin_egreso.push(newElement);
        }
      });
    },

    sumaTransferencia() {
      const allTransferenciaData = [...this.data_transferencia, ...this.data_transferencia_reserva];
      const suma = allTransferenciaData.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    sumaTarjeta() {
      const allTarjetaData = [...this.data_tarjeta, ...this.data_tarjeta_reserva];
      const suma = allTarjetaData.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    sumaDeposito() {
      const allDepositoData = [...this.data_deposito, ...this.data_deposito_reserva];
      const suma = allDepositoData.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    sumaYape() {
      const allYapeData = [...this.data_yape, ...this.data_yape_reserva];
      const suma = allYapeData.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    sumaPlin() {
      const allPlinData = [...this.data_plin, ...this.data_plin_reserva];
      const suma = allPlinData.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    sumaRetiro() {
      const suma = this.movement_retiros.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    sumaDeposito() {
      const suma = this.movement_depositos.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    exportPdf: function () {
      window.open(
        this.$store.getters.get__url +
        "/beads/viewpdfreportegeneral/" +
        this.$store.getters.get_campu.id +
        "/" +
        this.bead.id,
        "_blank"
      );
    },
    /** expenses */
    mtdOpenModalExpense: function () {
      this.modalExpense = {
        title: "Registrar Egreso",
        modal_form: true,
        type: this.types,
        method: this.data_methodpayment,
      };
    },
    closeModalExpense: function () {
      this.modalExpense = {
        title: "Registrar Egreso",
        modal_form: false,
        type: this.types,
        method: this.data_methodpayment,
      };
    },
    commitModalExpense: function (expense) {
      this.post({
        url:
          this.$store.getters.get__url +
          "/beads/expense/store/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
        params: {
          expense: expense,
          bead: this.bead,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.closeModalExpense();
            this.mtdGetData();
            Swal.fire({
              title: "Egreso registrado correctamente",
              icon: "success",
            });
          } else {
            Swal.fire({
              title: "Error al registrar",
              icon: "error",
            });
          }
        })
        .catch((errors) => { });
    },
    /** arqueo */
    mtdContarBilletes() {
      let total = 0;
      this.billetes.forEach((element) => {
        let can = 0;
        if (!element.cantidad) {
          can = 0;
        }
        can =
          element.cantidad != "" && element.cantidad != null
            ? parseFloat(element.cantidad).toFixed(2)
            : 0;
        let tot = parseFloat(element.value).toFixed(2);
        element.total = tot == NaN ? 0 : parseFloat(can * tot).toFixed(2);
        total += parseFloat(element.total);
      });

      this.monedas.forEach((element) => {
        let can = 0;
        if (!element.cantidad) {
          can = 0;
        }
        can =
          element.cantidad != "" && element.cantidad != null
            ? parseFloat(element.cantidad).toFixed(2)
            : 0;
        let tot = parseFloat(element.value).toFixed(2);
        element.total = tot == NaN ? 0 : parseFloat(can * tot).toFixed(2);
        total += parseFloat(element.total);
      });
      this.finalCash = total;
    },
    filterKey: function (e) {
      let b = false;
      b = /^[0-9]+$/.test(e.key);
      if (b == false && e.key != "Backspace") {
        e.preventDefault();
      }
    },
    handleChangePaymentMethod(changeData) {
      const { oldMethodId, newMethodId, totalAmount, selectedChargeIds } = changeData;
      
      // Validar si el origen es EFECTIVO y hay suficiente
      const oldMethod = this.data_methodpayment.find(method => method.id == oldMethodId);
      const newMethod = this.data_methodpayment.find(method => method.id == newMethodId);
      
      if (oldMethod && oldMethod.name == 'EFECTIVO') {
        if (this.bead.final < totalAmount) {
          Swal.fire({
            title: '⚠️ Error de Fondos',
            html: `
              <div style="text-align: center; padding: 20px;">
                <div style="font-size: 1.2em; margin-bottom: 15px;">
                  <strong>No hay suficiente efectivo disponible</strong>
                </div>
                <div style="background-color: #fff3cd; padding: 15px; border-radius: 8px; border-left: 4px solid #ffc107;">
                  <div style="margin-bottom: 10px;">
                    <strong>Efectivo disponible:</strong> <span style="color: #dc3545; font-size: 1.3em;">S/ ${parseFloat(this.bead.final).toFixed(2)}</span>
                  </div>
                  <div>
                    <strong>Monto solicitado:</strong> <span style="font-size: 1.3em;">S/ ${parseFloat(totalAmount).toFixed(2)}</span>
                  </div>
                </div>
              </div>
            `,
            icon: 'error',
            confirmButtonText: 'Entendido',
            customClass: {
              confirmButton: 'btn btn-danger'
            },
            buttonsStyling: false,
          });
          return;
        }
      }
      
      // Confirmar el cambio con detalles visuales
      Swal.fire({
        title: '🔄 Confirmar Cambio de Método de Pago',
        html: `
          <div style="text-align: left; padding: 15px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
              <div style="flex: 1; text-align: center;">
                <div style="padding: 15px; background-color: #fff3cd; border-radius: 8px; border: 2px solid #ffc107;">
                  <div style="font-size: 0.9em; color: #856404; margin-bottom: 5px;">Método Origen</div>
                  <div style="font-size: 1.3em; font-weight: bold; color: #856404;">
                    <i class="fa fa-credit-card"></i> ${oldMethod.name}
                  </div>
                </div>
              </div>
              <div style="flex: 0; padding: 0 15px;">
                <i class="fa fa-arrow-right" style="font-size: 2em; color: #007bff;"></i>
              </div>
              <div style="flex: 1; text-align: center;">
                <div style="padding: 15px; background-color: #d4edda; border-radius: 8px; border: 2px solid #28a745;">
                  <div style="font-size: 0.9em; color: #155724; margin-bottom: 5px;">Método Destino</div>
                  <div style="font-size: 1.3em; font-weight: bold; color: #155724;">
                    <i class="fa fa-credit-card"></i> ${newMethod.name}
                  </div>
                </div>
              </div>
            </div>
            
            <div style="text-align: center; padding: 20px; background-color: #e3f2fd; border-radius: 8px; margin-top: 15px;">
              <div style="font-size: 0.9em; color: #1976d2; margin-bottom: 5px;">Monto a Transferir</div>
              <div style="font-size: 2em; font-weight: bold; color: #1976d2;">
                S/ ${parseFloat(totalAmount).toFixed(2)}
              </div>
              <div style="font-size: 0.85em; color: #666; margin-top: 5px;">
                ${selectedChargeIds.length} transacción(es) seleccionada(s)
              </div>
            </div>
            
            <div style="margin-top: 15px; padding: 10px; background-color: #f8f9fa; border-radius: 6px; text-align: center;">
              <small style="color: #6c757d;">
                ⚠️ Esta acción modificará los registros de la caja
              </small>
            </div>
          </div>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '<i class="fa fa-check"></i> Sí, Confirmar Cambio',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        customClass: {
          confirmButton: "btn btn-success btn-lg",
          cancelButton: "btn btn-secondary"
        },
        buttonsStyling: false,
        width: '650px',
      }).then((result) => {
        if (result.isConfirmed) {
          this.changePaymentMethodAPI(oldMethodId, newMethodId, totalAmount, selectedChargeIds);
        }
      });
    },
    changePaymentMethodAPI(oldMethodId, newMethodId, totalAmount, selectedChargeIds) {
      // Mostrar loading
      Swal.fire({
        title: 'Procesando...',
        html: `
          <div style="text-align: center; padding: 20px;">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
              <span class="sr-only">Cargando...</span>
            </div>
            <p style="margin-top: 15px; color: #6c757d;">Por favor espere mientras se procesa el cambio</p>
          </div>
        `,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      this.post({
        url: this.$store.getters.get__url + "/beads/changePaymentMethod",
        token: this.$store.getters.get__token,
        params: {
          bead_id: this.bead.id,
          old_method_id: oldMethodId,
          new_method_id: newMethodId,
          amount: totalAmount,
          selected_charge_ids: selectedChargeIds
        }
      })
      .then((response) => {
        if (response.statusCode == 200) {
          const oldMethod = this.data_methodpayment.find(m => m.id == oldMethodId);
          const newMethod = this.data_methodpayment.find(m => m.id == newMethodId);
          
          Swal.fire({
            title: '✅ Cambio Exitoso',
            html: `
              <div style="text-align: center; padding: 20px;">
                <div style="margin-bottom: 20px;">
                  <div style="display: inline-block; padding: 15px 25px; background-color: #d4edda; border-radius: 12px; border: 2px solid #28a745;">
                    <i class="fa fa-check-circle" style="color: #28a745; font-size: 3em;"></i>
                  </div>
                </div>
                <h4 style="color: #155724; margin-bottom: 15px;">Método de pago cambiado correctamente</h4>
                <div style="background-color: #f8f9fa; padding: 15px; border-radius: 8px; margin-top: 15px;">
                  <div style="margin-bottom: 10px;">
                    <strong>${oldMethod.name}</strong> 
                    <i class="fa fa-arrow-right" style="color: #007bff; margin: 0 10px;"></i> 
                    <strong style="color: #28a745;">${newMethod.name}</strong>
                  </div>
                  <div style="font-size: 1.3em; color: #1976d2; margin-top: 10px;">
                    <strong>S/ ${parseFloat(totalAmount).toFixed(2)}</strong>
                  </div>
                </div>
              </div>
            `,
            icon: 'success',
            confirmButtonText: '<i class="fa fa-check"></i> Entendido',
            customClass: {
              confirmButton: 'btn btn-success btn-lg'
            },
            buttonsStyling: false,
          });
          
          // Recargar datos
          this.mtdGetData();
          this.mtdReportBeads();
          this.showChargue();
          this.showMovement();
          
          // Cerrar modales
          this.closeModal();
          this.closeModalIncome();
        }
      })
      .catch((errors) => {
        console.log('Error al cambiar método:', errors);
        const errorMessage = errors?.data?.message || errors?.message || 'Error al cambiar el método de pago';
        const errorData = errors?.data?.data || {};
        
        Swal.fire({
          title: '❌ Error en la Operación',
          html: `
            <div style="text-align: center; padding: 20px;">
              <div style="margin-bottom: 20px;">
                <div style="display: inline-block; padding: 15px 25px; background-color: #f8d7da; border-radius: 12px; border: 2px solid #dc3545;">
                  <i class="fa fa-exclamation-triangle" style="color: #dc3545; font-size: 3em;"></i>
                </div>
              </div>
              <h4 style="color: #721c24; margin-bottom: 15px;">No se pudo completar el cambio</h4>
              <div style="background-color: #f8f9fa; padding: 15px; border-radius: 8px; text-align: left;">
                <p style="margin: 0; color: #495057;"><strong>Mensaje:</strong> ${errorMessage}</p>
                ${Object.keys(errorData).length > 0 ? `
                  <details style="margin-top: 10px;">
                    <summary style="cursor: pointer; color: #007bff;">Ver detalles técnicos</summary>
                    <pre style="text-align: left; font-size: 0.85em; background-color: #fff; padding: 10px; border-radius: 4px; margin-top: 10px; overflow: auto;">${JSON.stringify(errorData, null, 2)}</pre>
                  </details>
                ` : ''}
              </div>
            </div>
          `,
          icon: 'error',
          confirmButtonText: '<i class="fa fa-times"></i> Cerrar',
          customClass: {
            confirmButton: 'btn btn-danger'
          },
          buttonsStyling: false,
        });
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.bg-gris {
  background-color: #dee2e6;
}

.bg-purple {
  background-color: #926cdc;
}

.color-white {
  color: white;
}
</style>